import type { SoundEnumType } from '@mark43/cad-api';
import type { SoundName } from '../sounds/play-sound';

// Every sound an admin can pick must map to a bundled file. Keyed by the backend's Sound enum, so adding
// a value there without a file here fails typecheck instead of silently playing the default.
const configurableSoundAssets: Record<SoundEnumType, SoundName> = {
    NEW_EVENT_ALERT: 'new-event-alert',
    UNIT_TIMER_ALERT: 'unit-timer-alert',
    DRAFT_EVENT_TIMER_ALERT: 'draft-event-timer-alert',
    AED_ATTEMPTING_ACCEPTING: 'aed-attempting-accepting',
    DEX_HOT_HIT_ALERT: 'dex-hot-hit-alert',
    NEW_MESSAGE_RECEIVED: 'new-message-received',
    FIRST_RESPONDER_INCOMING_MESSAGE: 'first-responder-incoming-msg',
    FIRST_RESPONDER_INCOMING_BOLO: 'first-responder-incoming-bolo',
    EMERGENCY_SIREN: 'emergency-siren',
};

/**
 * Undefined for a name this build doesn't know. That only happens while the backend is ahead of a
 * CDN-loaded client, and callers fall back to today's default sound.
 */
export function toSoundAsset(sound: string): SoundName | undefined {
    return Object.prototype.hasOwnProperty.call(configurableSoundAssets, sound)
        ? configurableSoundAssets[sound as SoundEnumType]
        : undefined;
}
